import get from 'lodash/get';

import { ADD_FAVORITE_SUCCESS } from '../redux/favorites';

import type {
  EventTracking,
  AddFavoriteSuccess,
  Store,
  AddFavoriteSuccessTracker,
} from '../types';

/** @type {ActionType} */
export const pbr_add_favorite_success = 'pbr_add_favorite_success';

function addFavoriteSuccess(
  action: AddFavoriteSuccess,
  state: Store,
): AddFavoriteSuccessTracker {
  const context =
    get(state, 'router.route') === '/cards/card/:id' ? 'pdp' : 'plp';
  return {
    id: get(action, 'payload.packageId'),
    favorite_origin_area: context,
  };
}

// Make sure you cast this before you export it in your duckling.
const tracking: EventTracking = {};
tracking[ADD_FAVORITE_SUCCESS] = addFavoriteSuccess;

export default tracking;
